/*
60 = 1 min
300 = 5 mins
1800 = 30 mins


The auth token is set to last 8 hours.  If there is 5 minutes left on the token and the
user is still active then the token will automatically be refreshed.

If a user has been inactive for 1 hour they will be signed out.

{
    accessTokenExpiryCheckInterval: 60seconds,
    silentRefreshAccessTokenTime: 5 mins,
    inactivityTimerReminder: 8 hour,
    inactivityTimerWarningDuration: 1 min
};


 */

const authConfig = {
    accessTokenExpiryCheckInterval: 60,
    silentRefreshAccessTokenTime: 300,
    inactivityTimerReminder: 28800,
    inactivityTimerWarningDuration: 60
};

export default authConfig;